<template>
    <div>
      <a :href="tweetUrl" class="twitter-share-button" target="_blank">
        Tweet
      </a>
    </div>
  </template>
  
  <script setup lang="ts">
  
  const props = {
      url: {
        type: String,
        required: true
      },
      text: {
        type: String,
        required: true
      }
  }
  const tweetUrl= `https://twitter.com/intent/tweet?text=${props.text}&url=${props.url}`;

  </script>
  